import * as types from '../actions/actionTypes';

const initialState = {
  open: false
};

const accountMenu = (state = initialState, action) => {
  switch (action.type) {
    case types.TOGGLE_ACCOUNT_MENU:
      return {
        ...state,
        open: !state.open
      };
    default:
      return state;
  }
};

export default accountMenu;
